export default __webpack_public_path__ + "static/media/dogHeart.a1c2d7fd.png";